import React, { useEffect, useRef, useState } from "react";
import { post } from '@polarnopyret/scope';

const ADYEN_SCRIPT = 'https://checkoutshopper-live.cdn.adyen.com/checkoutshopper/sdk/6.17.0/adyen.js';
const ADYEN_SCRIPT_INTEGRITY = 'sha384-5Osour7FS1pCTlxBjRBebSxRQRc5nqkmGymTwtcyOB/beMzqwoPPXvwQW4zMGWQl';
const ADYEN_CSS = 'https://checkoutshopper-live.cdn.adyen.com/checkoutshopper/sdk/6.17.0/adyen.css';
const ADYEN_CSS_INTEGRITY = 'sha384-lCDmpxn4G68y4vohxVVEuRcbz4iZTDh1u/FLlsCV1wSbibWKs+knhLQpgzPBqap4';

type PropType = {
    widgetData: string;
    allowCompletion: boolean;
    active: boolean;
    sessionId: string;
    onLoaded: () => void;
};

type ResponseType = {
    paymentMethods: any[],
    environment: string,
    locale: string,
    countryCode: string,
    clientKey: string,
    sessionId: string,
    amount: {
        value: number,
        currency: string
    },
    apiUrl: string
};

type ApiResultType = {
    status: string,
    payment: any,
    url: string,
}

export default function AdyenPayment(props: PropType) {
    const dropinRef = useRef<HTMLDivElement>(null);
    const [isAdyenWebInitialized, setIsAdyenWebInitialized] = useState<boolean>(false);
    const adyenResponse = props.widgetData ? JSON.parse(props.widgetData) as ResponseType : null;
    const [adyenDropin, setAdyenDropin] = useState<any>(null);
    const [sessionId, setSessionId] = useState<string>(props.sessionId);

    const initiatePayment = async (data: any) => {
        try {
            const valitaion = await post(adyenResponse.apiUrl, data);
            const result = await valitaion.json();
            return {
                status: 'Success',
                payment: result.payment,
                url: result.url
            } as ApiResultType;
        } catch (error) {
            return {
                status: 'Failed',
                payment: null,
                url: null
            } as ApiResultType;
        }
    };

    const handleServerResponse = (serverResponse, component) => {
        const { status, payment, url } = serverResponse;

        if (status === "Success") {
            if (payment.action) {
                component.handleAction(payment.action);
            } else {
                window.location.href = url;
            }
        } else {
            window.location.href = url;
        }
    };

    const initWidget = async () => {
        try {
            await loadScript(ADYEN_SCRIPT.replace('{env}', adyenResponse.environment), ADYEN_SCRIPT_INTEGRITY);
            await loadCss(ADYEN_CSS.replace('{env}', adyenResponse.environment), ADYEN_CSS_INTEGRITY);
        } catch (error) {
        }

        const globalConfiguration = {
            paymentMethodsResponse: adyenResponse.paymentMethods,
            environment: adyenResponse.environment,

            amount: {
                value: adyenResponse.amount.value,
                currency: adyenResponse.amount.currency
            },
            locale: adyenResponse.locale,
            countryCode: adyenResponse.countryCode,
            clientKey: adyenResponse.clientKey,

            onAdditionalDetails: async (state, component, actions) => {
                try {
                    console.log("additional");
                    // Make a POST /payments/details request from your server.
                    //const result = await makeDetailsCall(state.data);

                    // If the /payments/details request from your server fails, or if an unexpected error occurs.
                    // if (!result.resultCode) {
                    //     actions.reject();
                    //     return;
                    // }

                    // const {
                    //     resultCode,
                    //     action,
                    //     order,
                    //     donationToken
                    // } = result;

                    // // If the /payments/details request request from your server is successful, you must call this to resolve whichever of the listed objects are available.
                    // // You must call this, even if the result of the payment is unsuccessful.
                    // actions.resolve({
                    //     resultCode,
                    //     action,
                    //     order,
                    //     donationToken,
                    // });
                } catch (error) {
                    console.error("onAdditionalDetails", error);
                    actions.reject();
                }
            },
            onSubmit: async (state, component, actions) => {
                //console.info(state, component, actions);

                if (state.isValid && props.allowCompletion) {
                    const serverResponse = await initiatePayment(state.data);
                    handleServerResponse(serverResponse, component);
                }
                else {
                    //console.error("onSubmit", error);
                    actions.reject();
                }
            },
            onPaymentCompleted: (result, component) => {
                //console.info(result, component);
                console.log("onPaymentCompleted");
            },
            onPaymentFailed: (result, component) => {
                //console.info(result, component);
                console.log("onPaymentFailed");
            },
            onError: (error, component) => {
                console.error(error.name, error.message, error.stack, component);
            }
        };

        // All of the resources that you imported are properties of the window.
        const { AdyenCheckout, Dropin } = (window as any).AdyenWeb;
        const checkout = await AdyenCheckout(globalConfiguration);

        const cardConfiguration = {
            // hasHolderName: true, // Show the cardholder name field.
            // holderNameRequired: true, // Mark the cardholder name field as required.
            // billingAddressRequired: true, // Show the billing address input fields and mark them as required.
            maskSecurityCode: true
        };

        const dropinConfiguration = {
            paymentMethodsConfiguration: {
                card: cardConfiguration,
            },
            // Optional configuration.
            onReady: () => { },
        };

        if (dropinRef.current) {
            var dropIn = new Dropin(checkout, dropinConfiguration);
            setAdyenDropin(dropIn);
            dropIn.mount(dropinRef.current);
        }
    };

    useEffect(() => {
        if (props.active && adyenResponse && !isAdyenWebInitialized) {
            setIsAdyenWebInitialized(true);
            void initWidget();
        }

        if (props.active && props.onLoaded) {
            props.onLoaded();
        }

    }, [isAdyenWebInitialized, props.active]);

    useEffect(() => {
        if (props.active && adyenDropin !== null) {
            adyenDropin.unmount();
            if (adyenResponse) {
                void initWidget();
            }
        }
    }, [sessionId]);

    return <div ref={dropinRef}></div>;
}

const scripts: { [url: string]: Promise<void> } = {};
const scriptElements: { [url: string]: HTMLScriptElement } = {};

type ScriptCallback = (element: HTMLScriptElement) => HTMLScriptElement;

const loadScript = (url: string, integrity: string, callback?: ScriptCallback): Promise<void> => {
    if (!(url in scripts)) {
        let element = document.createElement('script');
        element.integrity = integrity;
        element.crossOrigin = 'anonymous';
        element.src = url;
        if (callback) {
            element = callback(element);
        }
        scripts[url] = new Promise<void>((resolve, reject) => {
            element.onload = () => {
                scriptElements[url] = element;
                resolve();
            };
            element.onerror = reject;
            document.body.appendChild(element);
        });
    }
    return scripts[url];
};

const unloadScript = function (url: string) {
    const element = scriptElements[url];
    if (element) {
        delete scriptElements[url];
        delete scripts[url];
        console.debug('Removing script element for', url);
        document.body.removeChild(element);
    }
}

const css: { [url: string]: Promise<void> } = {};
const cssElements: { [url: string]: HTMLStyleElement } = {};

const loadCss = (url: string, integrity: string): Promise<void> => {
    if (!(url in css)) {
        let element = document.createElement('link');
        element.type = 'text/css';
        element.rel = 'stylesheet';
        element.crossOrigin = 'anonymous';
        element.href = url;
        element.integrity = integrity;

        css[url] = new Promise<void>((resolve, reject) => {
            element.onload = () => {
                cssElements[url] = element;
                resolve();
            };
            element.onerror = reject;
            document.body.appendChild(element);
        });
    }
    return css[url];
};

const unloadCss = function (url: string) {
    const element = cssElements[url];
    if (element) {
        delete cssElements[url];
        delete css[url];
        console.debug('Removing script element for', url);
        document.body.removeChild(element);
    }
}
